import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  Model,
  QueryParams,
  PagedResponse,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

import { PagedResponseTo } from "@ofqual/portal-core/core/utils/pagedResponseHelpers";
import { News, fromApiModel } from "../domain/News";

export class NewsService extends BaseRemoteService {
  public async get(id: string, opts: Opts): Promise<News> {
    const url = `${this.apiRoot}/news/${id}`;
    const response = await super.getRequest<Model>(url, opts);

    return fromApiModel(response);
  }

  public async search(
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<News>> {
    //API handles the articles a user can see (news admin can see unpublished and archived)
    params.includeRss = true;
    const url = `${this.apiRoot}/news/${paramsToSearchString(params)}`;
    const response = await super.getRequest<PagedResponse<Model>>(url, opts);
    return PagedResponseTo<News>(response, fromApiModel);
  }

  public async downloadAttachment(
    id: string,
    blobId: string,
    opts: Opts
  ) {
    const url = `${this.apiRoot}/news/${id}/attachments/${blobId}/download`;
    return await super.getRequestBlob(url, opts);
  }
}
